module.exports = __webpack_public_path__ + "static/christian-2-881f62aff9e918822c64c2e38ff79ca0.png";